export default __webpack_public_path__ + "static/media/Slide24.bd6d92e8.JPG";